import StoresCountdownProvider from '@components/countdown/StoresCountdownProvider'
import { TabProps, useStoresSaleContext } from '@components/tickets/StoresSaleContext'
import ContentElement, { ContentItem } from '@components/webpage/ContentElement'
import { useAnalytics } from '@lib/analytics'
import { Theme } from '@lib/theming/Theme'
import { Box, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import Head from 'next/head'
import React from 'react'

import StoreSalesTabsProvider from '../tabs/StoreSalesTabsProvider'
import SalesProvider from '../tickets/release_phase_stepper/SalesProvider'
import StoresTicketApplicationsPage from './StoresTicketApplicationsPage'
import StoresTicketSalesPage from './StoresTicketSalesPage'

const StoresSalesPageProvider = () => {
  const {
    activeTabIndex,
    store,
    tabs,
    categoriesMenu,
    countdownSales,
    currentCountdownSale,
    releasePhaseSales,
    setActiveTabIndex,
  } = useStoresSaleContext()
  const { trackPage } = useAnalytics()
  const activeTab = tabs?.[activeTabIndex]
  const { palette, breakpoints } = useTheme<Theme>()
  const mdUp = useMediaQuery(breakpoints.up('md'))
  const handleTabChange = (i?: number, url?: string) => {
    if (activeTabIndex !== i && setActiveTabIndex) {
      setActiveTabIndex(i || 0)
      window.history.replaceState({ ...window.history.state, as: url, url }, '', url)
      window.setTimeout(trackPage)
    }
  }

  const pageContent = (tab: TabProps) => {
    return tab?.webPage?.content.map(item => {
      if (item.__typename === 'ComponentWebLayoutsStoresTicketSalesPage') {
        return (
          <StoresTicketSalesPage
            key={item.id}
            benefitsList={tab.benefitsList}
            country={store?.country as string}
            currencySymbol={store?.currencySymbol as string}
            products={tab.products}
            ticketReleasesPanel={item.ticketReleasesPanel}
          />
        )
      }
      if (item.__typename === 'ComponentWebLayoutsStoresTicketApplicationsPage') {
        return (
          <StoresTicketApplicationsPage
            key={item.id}
            country={store?.country as string}
            currencySymbol={store?.currencySymbol as string}
            description={item.description}
            overviewPanel={item.applicationOverviewPanel}
            priceIncreaseCountdownProductId={
              item.priceIncreaseCountdownTimer?.product?.sourceId || ''
            }
            product={tab.products?.[0]}
            releasePhaseStepperProductId={item.releasePhaseStepper?.product?.sourceId || ''}
            ticketApplicationForm={item.applicationForm}
            ticketInfoPanel={item.ticketInfoPanel}
            title={item.title}
          />
        )
      }
      return <ContentElement key={item.id} item={item as ContentItem} />
    })
  }

  return (
    <Box bgcolor={palette.grey[50]}>
      <Head>
        <title>{activeTab?.webPage?.seoTags?.title || activeTab?.webPage?.title}</title>
      </Head>
      {countdownSales && currentCountdownSale && (
        <StoresCountdownProvider currentSale={currentCountdownSale} sales={countdownSales} />
      )}

      {categoriesMenu?.menuItems && categoriesMenu.menuItems?.length > 0 && (
        <StoreSalesTabsProvider
          menuItems={categoriesMenu.menuItems}
          page="/tickets/[slug]"
          selectedMenuIndex={activeTabIndex}
          onChange={handleTabChange}
        />
      )}

      {releasePhaseSales && mdUp && <SalesProvider sales={releasePhaseSales} />}
      {tabs?.map(tab => {
        return (
          <div key={tab.path} style={{ display: activeTab?.path === tab.path ? 'block' : 'none' }}>
            {pageContent(tab)}
          </div>
        )
      })}
    </Box>
  )
}

export default StoresSalesPageProvider
